<template>
  <div class="main-container container-xxl">
    <titulo-grande texto="Cadastro de Notícias" posicao="left" />
    <modal :tituloModal="textoBtnCadastro" @fecha_modal="fecha_modal" @hidden="fecha_modal"
      textoBtnChamada="Inserir notícia" @click_bt_modal="click_bt_modal" :exibe_botao="true">
      <template #default>
        <form @submit.prevent="cadastrar" enctype="multipart/form-data" id="cad_news">
          <InputText placeholder="" label="Link da notícia" tamanho="sm" nome="link_amistoso" v-model="link_amistoso"
            :desabilitado="true" />
          <fieldset>
            <div class="row mb-3">
              <div class="col-md-7 col-lg-8">
                <InputText placeholder="" label="Titulo da notícia *" tamanho="sm" nome="titulo" ref="titulo"
                  v-model="titulo" />
              </div>

              <div class="col-md-5 col-lg-4">
                <InputSelect name="categoria" ref="categoria" v-model="categoria" :dados="dados_categoria"
                  api_link="news_category/list_select" label="Categoria" />
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-md-7 col-lg-8">
                <InputText placeholder="" label="Subtítulo da notícia *" tamanho="sm" nome="sub_titulo" ref="sub_titulo"
                  v-model="sub_titulo" />
              </div>

              <div class="col-md-5 col-lg-4">
                <InputSelect name="destaque" ref="destaque" v-model="destaque" :dados="[{ valor: 'n', texto: 'Não' },{ valor: 's', texto: 'Sim' }]" label="Destaque?" />
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <InputText placeholder="" label="Breve descricao" tamanho="sm" nome="breve_descricao" ref="breve_descricao"
                  v-model="breve_descricao" />
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <InputText placeholder="" label="Link do vídeo do youtube" tamanho="sm" nome="link_video"
                  ref="link_video" v-model="link_video" />
              </div>
              <div class="col-md-8">
                <InputText placeholder="" label="Imagem de destaque" tipo="file" tamanho="sm" nome="imagem_destaque"
                  ref="imagem_destaque" @change="previewImage" v-model="img_file" />
              </div>
              <div class="col-md-4">
                <div class="col-12 text-center">
                  <img :src="imagem_destaque" class="img img-fluid img-thumbnail" alt="">
                </div>
              </div>
            </div>

            <InputEditor name="conteudo" class="form-control" v-model="conteudo" />

            <br>
            <InputText placeholder="" nome="link_referencia" label="Link de Referencia" tamanho="sm"
              v-model="link_referencia" />
            <InputText placeholder="" nome="redator" label="Redator *" mask="redator" tamanho="sm" v-model="redator"
              :desabilitado="true" />

            <input type="submit" class="d-none" value="">
          </fieldset>
        </form>
      </template>
      <template #botaoPersonalizado>
        <fieldset>
          <button type="button" @click.prevent="cadastrar" class="btn btn-primary">Salvar
            <Spinner :visivel="false" id="loading" />
          </button>
        </fieldset>
      </template>
    </modal>

    <modal tituloModal="" @fecha_modal="fecha_modal" @hidden="fecha_modal" textoBtnChamada="" tamanho_modal="modal-md"
      :exibe_botao="false" id_modal="modal_delete">
      <template #default>
        Tem certeza que deseja deletar a notícia <strong>"{{ titulo_delete }}"</strong>?
      </template>
      <template #botaoPersonalizado>
        <fieldset>
          <button type="button" @click.prevent="deletar" class="btn btn-danger"><i class="bi bi-trash3-fill"></i>
            Deletar
            <Spinner :visivel="false" id="loading" />
          </button>
        </fieldset>
      </template>
    </modal>

    <TabelaDatatable :dadosData="dadosData" dadosAjax=""
      :ordem_tabela="[{ name: 'data_cadastro', dir: 'desc' }, { name: 'titulo', dir: 'asc' }]" :btnStatus="true"
      :btnEdit="true" :btnDelete="true" :columns="colunas" @edit_status="edit_status" @edit_row="dados_editar"
      @delete_row="deletar_dados" :ativa_placeholder="ativa_placeholder" modal_target_delete="#modal_delete">
    </TabelaDatatable>
  </div>
</template>

<script>
import TabelaDatatable from '@/components/TabelaDatatable.vue';
import TituloGrande from '@/components/TituloGrande.vue'
import Modal from '@/components/Modal.vue';
import InputText from "@/components/form/InputText.vue";
import InputEditor from '@/components/form/InputEditor.vue';
import { toastr } from '@/plugins/toast.js'
import { remove_acento } from '@/assets/js/functions'
import { AuthStore } from '@/stores/Auth';
import { api } from '@/services/api';
import InputSelect from '@/components/form/InputSelect.vue';

export default {
  components: { TituloGrande, TabelaDatatable, Modal, InputText, InputEditor, InputSelect },
  name: 'CadastrarNoticia',
  data() {
    return {
      auth: AuthStore(),
      id_delete: Number,
      titulo_delete: String,
      conteudo: '',
      link_video: '',
      titulo: '',
      sub_titulo: '',
      destaque: '',
      breve_descricao: '',
      categoria: '',
      imagem_destaque: '',
      link_referencia: '',
      redator: '',
      img_file: '',
      id_notc: null,
      img_data: null,
      dados_categoria: [
        { valor: '', texto: 'Selecione uma categoria' },
      ],
      colunas: [
        { data: 'titulo', title: 'Título', width: '40%' },
        { data: 'categoria', title: 'Categoria', width: '20%' },
        { data: 'autor', title: 'Autor', width: '20%' },
        { data: 'data_criacao', title: 'Data da criação', width: '10%' },
        { name: 'acoes', data: 'status', title: 'Ações', width: '10%' },
      ],
      dadosData: '',
      textoBtnCadastro: 'Cadastro de Notícia',
      ativa_placeholder: Boolean,
    }
  },
  computed: {
    link_amistoso: function () {
      return remove_acento(this.titulo)
    }
  },
  mounted() {
    this.redator = this.auth.nomeUserCompleto;
    this.listagemTabela();

    const modal = document.getElementById("modal_cadastrar")
    modal.addEventListener('shown.bs.modal', event => {
      modal.focus()
    })
  },
  methods: {
    async listagemTabela() {
      this.ativa_placeholder = true
      this.dadosData = await api.post('news/list')
      this.ativa_placeholder = false
    },
    async cadastrar(e) {
      e.preventDefault();

      if (!this.titulo) {
        toastr.alerta("Digite o titulo")
        return false;
      }

      if (!this.redator) {
        toastr.alerta("Digite seu redator")
        return false;
      }

      const formu = document.querySelector("#cad_news")

      const dados = new FormData(formu)
      dados.append('link_amistoso', this.link_amistoso)
      if (this.img_data) {
        dados.append('imagem_destaque', this.img_data)
      }
      if (this.id_notc > 0) {
        dados.append('id', this.id_notc)
      }
      dados.append('conteudo', this.conteudo)
      dados.append('redator', this.redator)

      this.bloqueia_campos()
      try {
        const data = await api.post('news/register', dados, { Authorization: this.auth.token }, false)
        
        if (data?.status >= 400) {
          for (const key in data.message) {
            toastr.erro(data.message[key]);
          }
        } else if (data?.status == 200) {
          toastr.sucesso(data.message)
          if (!this.id_notc) {
            this.limpa_campos()
          }
          this.listagemTabela()
        } else {
          toastr.erro("Erro ao cadastrar a notícia, tente novamente dentro de alguns minutos.")
        }
      } catch (error) {
        toastr.erro("Erro ao cadastrar.");
      }
      this.bloqueia_campos(false)
    },
    bloqueia_campos(opt = true) {
      const campos = document.querySelector('fieldset')
      const loading = document.querySelector('#loading')
      if (opt) {
        loading.classList.remove('d-none');
        campos.setAttribute('disabled', 'disabled')
      } else {
        campos.removeAttribute('disabled')
        loading.classList.add('d-none');
      }
    },
    previewImage: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imagem_destaque = e.target.result;
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
        this.img_data = input.files[0]
      } else {
        this.img_data = null;
      }
    },
    async edit_status(dados) {
      try {
        var sts = (dados.cellData == 'Ativo' ? 'Inativo' : 'Ativo')
        var id = dados.rowData.id
        var autoriza = await api.autoriza();

        const stat = {
          status: sts,
          id: id,
        }

        if (autoriza) {
          try {
            const data = await api.post('news/change_status', stat)
            if (data.status == 200) {
              var mgn = `Status de ${dados.rowData.titulo} alterado para ${sts}`;
              if (sts == 'Ativo') {
                toastr.sucesso(mgn)
              } else {
                toastr.alerta(mgn)
              }
              this.listagemTabela()
            } else {
              toastr.erro('Erro ao alterar o status, tente novamente em alguns instantes.')
            }
          } catch (error) {
            toastr.erro('Erro ao se comunicar com a API, tente novamente em alguns instantes.')
          }
        } else {
          toastr.erro("É preciso estar logado como admin para esta ação.")
          this.$router.push('/login')
        }
      } catch (error) {
        toastr.erro("Erro na solicitação, tente novamente em alguns instantes.")
      }
    },
    async dados_editar(dados) {
      this.bloqueia_campos()
      var dadosEdit = await api.post('news/list/' + dados.rowData.id)
      
      this.conteudo = dadosEdit.corpo;
      this.link_video = dadosEdit.link_video;
      this.titulo = dadosEdit.titulo;
      this.sub_titulo = dadosEdit.sub_titulo;
      this.destaque = dadosEdit.destaque;
      this.breve_descricao = dadosEdit.breve_descricao;
      this.categoria = dadosEdit.id_categoria;
      if (dadosEdit.imagem) {
        this.imagem_destaque = "/img/news/" + dadosEdit.imagem;
      }
      this.link_referencia = dadosEdit.link_referencia;
      this.id_notc = dados.rowData.id;
      this.redator = dadosEdit.autor;

      document.querySelector("#btn_modal_cadastrar").click()
      this.bloqueia_campos(false)
    },
    fecha_modal() {
      this.limpa_campos()
    },
    limpa_campos() {
      this.conteudo = '';
      this.link_amistoso = '';
      this.id_notc = null;
      this.titulo = '';
      this.sub_titulo = '';
      this.destaque = '';
      this.breve_descricao = '';
      this.categoria = '';
      this.imagem_destaque = '';
      this.link_referencia = '';
      this.img_file = '';
      this.img_data = null;
    },
    atribui_dados(dados) {
      this.conteudo = dados.conteudo;
      this.link_amistoso = dados.link_amistoso;
      this.titulo = dados.titulo;
      this.sub_titulo = dados.sub_titulo;
      this.destaque = dados.destaque;
      this.breve_descricao = dados.breve_descricao;
      this.categoria = dados.categoria;
      this.imagem_destaque = dados.imagem_destaque;
      this.link_referencia = dados.link_referencia;
      this.redator = dados.redator;
      this.img_file = dados.img_file;
      this.img_data = dados.img_data;
    },
    click_bt_modal() {
      if (this.id_notc > 0) {
        this.textoBtnCadastro = 'Editando notiícia: ' + this.titulo
      } else {
        this.textoBtnCadastro = 'Cadastro de Notícia'
      }
    },
    deletar_dados(dados) {
      this.id_delete = dados.rowData.id
      this.titulo_delete = dados.rowData.titulo
    },
    async deletar() {
      this.bloqueia_campos()
      var autoriza = await api.autoriza();

      if (autoriza) {
        try {
          var deletar = await api.post('news/delete/' + this.id_delete)
          if (deletar.status == 200) {
            toastr.sucesso(deletar.message)
            this.listagemTabela()
            document.querySelector("#btn_close_modal_delete").click()
          } else {
            toastr.erro(deletar.message)
          }
        } catch (error) {
          toastr.erro(error)
        }
        this.bloqueia_campos(false)
      }
    }
  },
}
</script>